var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63.71 60.96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ec6747;\n        stroke-miterlimit: 10;\n        stroke-width: 2.97px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -8.881784197001252e-16, -4.440892098500626e-16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.85,2.72l7.66,15.53c.32.65.95,1.11,1.67,1.22l17.14,2.49c1.82.26,2.55,2.5,1.23,3.79l-12.4,12.09c-.52.51-.76,1.24-.64,1.96l2.93,17.07c.31,1.81-1.59,3.2-3.22,2.34l-15.33-8.06c-.65-.34-1.42-.34-2.07,0l-15.33,8.06c-1.63.86-3.53-.53-3.22-2.34l2.93-17.07c.12-.72-.12-1.45-.64-1.96L2.16,25.75c-1.32-1.28-.59-3.52,1.23-3.79l17.14-2.49c.72-.1,1.35-.56,1.67-1.22l7.67-15.53c.81-1.65,3.17-1.65,3.98,0Z",
    style: {
      fill: "rgb(236, 103, 71)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6c9cb2d771f42f63bfd1bd1ad240c037.svg";
export { ForwardRef as ReactComponent };